<template>
  <section class="dte-card">
    <div class="dte-card__header">{{ title }}</div>
    <div class="dte-card__body" style="padding: 0;">
      <table class="dte-table" style="border: none;">
        <thead>
          <tr>
            <th>Tipo</th>
            <th>Numero</th>
            <th>Fecha / Detalle</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(document, index) in documents" :key="`${title}-${index}`">
            <td>{{ document.typeLabel }}</td>
            <td>{{ document.number }}</td>
            <td>{{ document.date }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
export default {
  name: "DteRelatedDocumentsSection",
  props: {
    title: {
      type: String,
      default: "Documentos Relacionados",
    },
    documents: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
